import { useDataQuery } from "@Libs/DataLayer/hooks/useDataQuery";
import { getRecommendations } from "../services/recommendations";
import { IRecommendationsResponse } from "../types/recommendations.types";

export const RECOMMENDATIONS_QUERY_KEY = "recommendations";

interface IUseRecommendationsResult {
  placeName: IRecommendationsResponse["place_name"] | undefined;
  serviceProvidersCount: IRecommendationsResponse["service_providers_count"] | undefined;
  isLoading: boolean;
  isError: boolean;
}

export const useRecommendations = (): IUseRecommendationsResult => {
  const { data, isLoading, isError } = useDataQuery(
    [RECOMMENDATIONS_QUERY_KEY],
    () => getRecommendations().then(({ data }) => data)
  );

  return {
    placeName: data?.place_name,
    serviceProvidersCount: data?.service_providers_count,
    isLoading,
    isError,
  };
};
